import $ from "jquery";

$.turbo.use("turbolinks:load", "turbolinks:request-start");
